import { Button } from "antd";
import { FeedingMap } from "./map";
import { useTranslation } from "react-i18next";
import { useGetFertilizerMarchQuery } from './api';
import { useGetTerritorialUnitsGetpolygonsListQuery } from "../../../redux/api/handBooksApi/territorialUnitsApi";
import style from "./style.module.css";
import { useState, useCallback } from "react";
import { EntTerritorialUnitsFilter } from "../../../models/filters/territorialUnitsFilter";
import { PreloaderSvg } from "../../preloaderSvg/PreloaderSvg";
import ReportChemicalization from "../../../pages/admin/chemicalization/reportChemicalization/ReportChemicalization";
import { PlusOutlined } from "@ant-design/icons";
import { useReportFertilizerUsageMutation } from "../../../redux/api/chemicalization/fertilizerUsage";

export const Feeding = () => {
    const { t } = useTranslation();
    const [selectedYear, setSelectedYear] = useState<number | null>(null);
    const [selectedRegionId, setSelectedRegionId] = useState<number | "">("");
    const [selectedRegionName, setSelectedRegionName] = useState<string>("");
    const [showReportModal, setShowReportModal] = useState<boolean>(false);
    const [getReportFertilizerUsage] = useReportFertilizerUsageMutation();
    const openReportModal = () => {
        setShowReportModal(true);
      };

      const getReport = async (payload: { periodStart: string; periodEnd: string; language: string }): Promise<Blob> => {
        return await getReportFertilizerUsage(payload).unwrap();
      };
    const { data: polygonsData, isLoading: polygonsLoading } = useGetTerritorialUnitsGetpolygonsListQuery(
        new EntTerritorialUnitsFilter({ page: 1, size: 15 })
    );

    const { data: fertilizercropsData, isLoading: isLoadingCropFertilizers } = useGetFertilizerMarchQuery({
        year: selectedYear ? selectedYear.toString() : undefined,
        territorialUnitRegionId: selectedRegionId 
    });

    const handleRegionClick = useCallback((regionId: number, regionName: string) => {
        setSelectedRegionId(regionId);
        setSelectedRegionName(regionName);
    }, []);

    const handleResetRegion = useCallback(() => {
        setSelectedRegionId("");
        setSelectedRegionName("");
    }, []);

    const isLoading = polygonsLoading || isLoadingCropFertilizers;
    if (isLoading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <PreloaderSvg />
            </div>
        );
    }

    
    return (
        <div className={style.container}>
           
                <div className={style.title}>
                    <div className={style.title_header}>
                        <h1>{t('Soil composition enrichment (Fertilizing: March-September)')}</h1>
                        <Button style={ { marginLeft: '5px' } } type="primary" icon={<img src="../../../report.svg" alt="Plus Icon" style={{ width: '16px', height: '16px' }} />}
			  onClick={ () => openReportModal() }>
		{ t('reports.report_by_fertilizer_usage') }
	  </Button>
      <ReportChemicalization
      title={t('report')}
		getReport={ getReport }
		show={ showReportModal }
		onHide={ () => setShowReportModal(false) }
	  />
                    </div>
                    <div className={style.title_inner}>
                        <img src="./homeicon.svg" alt="home" />
                        <p>{t('Home')}</p>
                        <img src="./arrowright.svg" alt="arrow" />
                        <p>{t('Mineral fertilizers')}</p>
                        <img src="./arrowright.svg" alt="arrow" />
                        <span>{t('Soil composition enrichment (Fertilizing: March-September)')}</span>
                    </div>
                </div>

                <div className={style.mapcontainer}>
                    <FeedingMap
                        latitude={41.5089324}
                        longitude={74.724091}
                        fertilizercropsData={fertilizercropsData}
                        polygonsData={polygonsData}
                        selectedYear={selectedYear}
                        onYearChange={setSelectedYear}
                        onRegionClick={handleRegionClick}
                        onResetRegion={handleResetRegion}
                        isLoading={isLoadingCropFertilizers}
                        selectedRegionName={selectedRegionName}
                    />
                </div>
            </div>
    );
};

function getReportFertilizerUsage(payload: { periodStart: string; periodEnd: string; language: string; }) {
    throw new Error("Function not implemented.");
}
